import api from '@/services/api';
import type { AddOnRecord } from './smr-admin';

const smrPath = '/smr';

export type FrequencyPeriod = 'day' | 'week' | 'month' | 'year';

export interface ProductAddOnPivot {
    id: string;
    price_override: string | null;
    gross_price_override: string | null;
    frequency_limit: number | null;
    frequency_period: FrequencyPeriod | null;
    quantity_limit: number | null;
    auto_include: boolean;
    mandatory: boolean;
    auto_include_link: string | null;
    created_at: string;
    updated_at: string;
}

export interface ProductAddOnRecord extends AddOnRecord {
    pivot: ProductAddOnPivot;
    effective_price: string;
    effective_gross_price: string;
    vat_rate_percent: string;
}

export interface AssignedProductRecord {
    id: string;
    name: string;
    status: string | null;
    effective_price: string;
    effective_gross_price: string;
    vat_rate_percent: string;
    pivot: Omit<ProductAddOnPivot, 'created_at' | 'updated_at'>;
}

export interface AssignAddOnPayload {
    addon_id: string;
    price_override?: string | null;
    frequency_limit?: number | null;
    frequency_period?: FrequencyPeriod | null;
    quantity_limit?: number | null;
    auto_include?: boolean;
    mandatory?: boolean;
    auto_include_link?: string | null;
}

export type UpdateAddOnAssignmentPayload = Omit<AssignAddOnPayload, 'addon_id'>;

export const fetchProductAddOns = async (productId: string): Promise<ProductAddOnRecord[]> => {
    const res = await api.get(`${smrPath}/products/${productId}/addons`);
    return (res.data.data ?? []) as ProductAddOnRecord[];
};

export const assignAddOnToProduct = async (
    productId: string,
    payload: AssignAddOnPayload,
): Promise<ProductAddOnRecord> => {
    const res = await api.post(`${smrPath}/products/${productId}/addons`, payload);
    return res.data.data as ProductAddOnRecord;
};

export const updateProductAddOn = async (
    productId: string,
    addonId: string,
    payload: UpdateAddOnAssignmentPayload,
): Promise<ProductAddOnRecord> => {
    const res = await api.put(`${smrPath}/products/${productId}/addons/${addonId}`, payload);
    return res.data.data as ProductAddOnRecord;
};

export const detachProductAddOn = async (productId: string, addonId: string): Promise<void> => {
    await api.delete(`${smrPath}/products/${productId}/addons/${addonId}`);
};

export const fetchAssignedProducts = async (addOnId: string): Promise<AssignedProductRecord[]> => {
    const res = await api.get(`${smrPath}/addons/${addOnId}/products`);
    return (res.data.data ?? []) as AssignedProductRecord[];
};
